import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useAtom } from "jotai";
import { mobileRightDrawerOpenAtom } from "../state";

export const MobileRightDrawer = () => {
    const [mobileRightDrawerOpen, setMobileRightDrawerOpen] = useAtom(
        mobileRightDrawerOpenAtom,
    );
    return (
        <AnimatePresence>
            <motion.div
                initial={{ x: "100%" }}
                animate={{ x: mobileRightDrawerOpen ? 0 : "100%" }}
                exit={{ x: "100%" }}
                transition={{
                    type: "spring",
                    damping: 30,
                    stiffness: 300,
                    duration: 0.3,
                }}
                className={clsx(
                    "fixed inset-0 z-50",
                    "flex flex-col bg-slate-800 text-white",
                    "lg:hidden",
                )}
            >
                <div
                    className={clsx("p-6", "flex items-center justify-between")}
                >
                    <button
                        type="button"
                        onClick={() => setMobileRightDrawerOpen(false)}
                        className={clsx(
                            "menu-item ui-element subdued text-sm",
                            "mb-4 flex cursor-pointer items-center gap-1",
                        )}
                    >
                        Close
                        <ChevronRightIcon className="size-3" color="#E5E7EB" />
                    </button>
                </div>

                <div
                    className={clsx(
                        "p-6",
                        "flex flex-1 flex-col",
                        "overflow-hidden",
                    )}
                >
                    <div
                        id="mobile-right-drawer-content"
                        className={clsx(
                            "min-h-0 flex-1 flex-col gap-5",
                            "hide-scrollbar flex overflow-y-auto",
                        )}
                    />
                </div>
            </motion.div>
        </AnimatePresence>
    );
};
